import { CountDestinationsResponse } from '@/core/domain/count-destinations/models/count-destinations.model';
import { CountDestinationsRepository } from '@/core/domain/count-destinations/repositories/count-destinations.repository';
import { environment } from '@/env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CountDestinationsImplRepository extends CountDestinationsRepository {
    constructor(private readonly httpClient: HttpClient) {
        super();
    }

    override getCountDestinations(): Observable<CountDestinationsResponse> {
        return this.httpClient
            .get<CountDestinationsResponse>(
                [
                    environment.alamoApi.BASE_HOST,
                    environment.alamoApi.ENDPOINTS.countDestinations,
                ].join('/'),
            )
            .pipe(
                switchMap(
                    (countDestinationsResponse: CountDestinationsResponse) => {
                        const countDestinations: CountDestinationsResponse = {
                            type: countDestinationsResponse.type,
                            action: countDestinationsResponse.action,
                            notifications:
                                countDestinationsResponse.notifications,
                            data: countDestinationsResponse.data,
                        };

                        return of(countDestinations);
                    },
                ),
            );
    }
}
